import { createContext } from 'react';

import SwellBoolean from './boolean';
import SwellColor from './color';
import SwellColorScheme from './color-scheme';
import SwellColorSchemeGroup from './color-scheme-group';
import SwellCSS from './css';
import SwellEditor from './editor';
import SwellFile from './file';
import SwellFont from './font';
import SwellHeader from './header';
import SwellParagraph from './paragraph';
import SwellIcon from './icon';
import SwellImage from './image';
import SwellLookup from './lookup';
import SwellNumber from './number';
import SwellMenu from './menu';
import SwellRadio from './radio';
import SwellSelect from './select';
import SwellText from './text';
import SwellTextarea from './textarea';
import SwellUrl from './url';
import SwellLocale from './locale';

export const WidgetContext = createContext({});

const widgets = {
  SwellBoolean,
  SwellColor,
  SwellColorScheme,
  SwellColorSchemeGroup,
  SwellCSS,
  SwellEditor,
  SwellFile,
  SwellFont,
  SwellHeader,
  SwellParagraph,
  SwellIcon,
  SwellImage,
  SwellLookup,
  SwellNumber,
  SwellMenu,
  SwellRadio,
  SwellSelect,
  SwellText,
  SwellTextarea,
  SwellUrl,
  SwellLocale,
};

export default widgets;
